import Vue from 'vue/dist/vue.esm'
import VueRouter from 'vue-router';
Vue.use(VueRouter)

import index from './index.vue'
import demo from './demo.vue'
import routes from '@routes/main.vue'

import stations_layout from '@stations/provider/layout.vue'
import stations_router from '@stations/provider/routes.js'

import partitions_layout from '@partitions/provider/layout.vue'
import partitions_router from '@partitions/provider/routes.js'

import staffs from '@staffs/provider/layout.vue'
import staffs_router from '@staffs/provider/routes.js'

import roles from '@roles/provider/layout.vue'
import roles_router from '@roles/provider/routes.js'

import distributions from '@components/distributions/provider/layout.vue'
import distributions_router from '@components/distributions/provider/routes.js'
import driver_commissions from '@components/driver_commissions/provider/layout.vue'
import driver_commissions_router from '@components/driver_commissions/provider/routes.js'

import customers from '@components/customers/provider/layout.vue'
import customers_router from '@components/customers/provider/routes.js'

import permission_denied from '@partials/permission_denied.vue'
import settings from '@settings/main.vue'
import uploader from '@uploader/provider/layout.vue'
import assets from '@assets/provider/layout.vue'
import status_prototypes from '@status_prototypes/provider/layout.vue'
import materials from '@materials/provider/layout.vue'
import permission_groups from '@permission_groups/provider/layout.vue'
import core_waybills from '@core_waybills/provider/layout.vue'
import packer from '@packer/main.vue'
import operations from '@operations/provider/layout.vue'
import appraisals from '@appraisals/provider/layout.vue'
import user_logs from '@user_logs/provider/layout.vue'
import driver_commission_policies from '@driver_commission_policies/provider/layout.vue'
import driver_commission_reports from '@driver_commission_reports/provider/layout.vue'
import scan_action_prototypes from '@scan_action_prototypes/provider/layout.vue'
import provider_node from '@provider_node/provider/layout.vue'

import settings_router from '@settings/routes.js'
import uploader_router from '@uploader/provider/routes.js'
import assets_router from '@assets/provider/routes.js'
import status_prototypes_router from '@status_prototypes/provider/routes.js'
import materials_router from '@materials/provider/routes.js'
import permission_groups_router from '@permission_groups/provider/routes.js'
import core_waybills_router from '@core_waybills/provider/routes.js'
import packer_router from '@packer/routes.js'
import operations_router from '@operations/provider/routes.js'
import appraisals_router from '@appraisals/provider/routes.js'
import user_logs_router from '@user_logs/provider/routes.js'
import driver_commission_policies_router from '@driver_commission_policies/provider/routes.js'
import driver_commission_reports_router from '@driver_commission_reports/provider/routes.js'
import scan_action_prototypes_router from '@scan_action_prototypes/provider/routes.js'
import provider_node_router from '@provider_node/provider/routes.js'

const router = [
    {
        path: '', component: index, name: 'provider_index',
    },
    {
        path: 'demo', component: demo, name: 'provider_demo',
    },
    {
        path: 'settings', component: settings,
        children: settings_router,
    },
    {
        path: 'partitions', component: partitions_layout,
        children: partitions_router,
    },
    {
        path: 'uploader', component: uploader,
        children: uploader_router
    },
    {
        path: 'assets', component: assets,
        children: assets_router
    },
    {
        path: 'stations', component: stations_layout,
        children: stations_router
    },
    {
        path: 'status_prototypes', component: status_prototypes,
        children: status_prototypes_router
    },
    {
        path: 'materials', component: materials,
        children: materials_router
    },
    {
        path: 'staffs', component: staffs,
        children: staffs_router
    },
    {
        path: 'permission_groups', component: permission_groups,
        children: permission_groups_router
    },
    {
        path: 'roles', component: roles,
        children: roles_router
    },
    {
        path: 'core_waybills', component: core_waybills,
        children: core_waybills_router
    },
    {
        path: 'packer', component: packer,
        children: packer_router
    },
    {
        path: 'operations', component: operations,
        children: operations_router
    },
    {
        path: 'appraisals', component: appraisals,
        children: appraisals_router
    },
    {
        path: 'user_logs', component: user_logs,
        children: user_logs_router
    },
    {
        path: 'driver_commission_policies', component: driver_commission_policies,
        children: driver_commission_policies_router
    },
    {
        path: 'driver_commission_reports', component: driver_commission_reports,
        children: driver_commission_reports_router
    },
    {
        path: 'scan_action_prototypes', component: scan_action_prototypes,
        children: scan_action_prototypes_router
    },
    {
        path: 'provider_node', component: provider_node,
        children: provider_node_router
    },
    {
        path: 'distributions', component: distributions,
        children: distributions_router
    },
    {
        path: 'driver_commissions', component: driver_commissions,
        children: driver_commissions_router
    },
    {
        path: 'customers', component: customers,
        children: customers_router
    },
    {
        path: 'routes', component: routes, name: 'routes',
    },
    {
        path: 'permission_denied', component: permission_denied, name: 'permission_denied',
    }
]

export default router;
